(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || document.documentElement.dataset.currency || 'AUD'
  }).format(cents / 100);

  const init = () => {
    document.querySelectorAll('[data-pbc-product]').forEach((root) => {
      if (root.dataset.pbcProductReady === 'true') return;
      root.dataset.pbcProductReady = 'true';
      const data = root.querySelector('[data-pbc-variants]');
      if (!data) return;
      let variants = [];
      try { variants = JSON.parse(data.textContent); } catch (_) { return; }

      const groups = [...root.querySelectorAll('[data-pbc-option-group]')];
      const idInput = root.querySelector('[data-pbc-variant-id]');
      const price = root.querySelector('[data-pbc-price]');
      const buttonPrice = root.querySelector('[data-pbc-button-price]');
      const perCard = root.querySelector('[data-pbc-per-card]');
      const add = root.querySelector('[data-pbc-add]');
      const addLabel = root.querySelector('[data-pbc-add-label]');

      const selectedOptions = () => groups.map((group) => group.querySelector('[data-pbc-option]:checked')?.value || '');
      const quantityFromOptions = (opts) => {
        for (let i = 0; i < groups.length; i++) {
          const label = groups[i].querySelector('.pbc-i-option-label')?.textContent?.trim().toLowerCase() || '';
          if (label.includes('quantity')) {
            const n = parseInt(String(opts[i]).replace(/[^0-9]/g, ''), 10);
            if (Number.isFinite(n) && n > 0) return n;
          }
        }
        return null;
      };

      const update = () => {
        const opts = selectedOptions();
        const variant = variants.find((v) => opts.every((o, i) => v.options[i] === o));
        if (!variant) {
          if (add) add.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = money(variant.price);
        if (buttonPrice) buttonPrice.textContent = money(variant.price);
        const qty = quantityFromOptions(opts);
        if (perCard) perCard.textContent = qty ? `${money(Math.round(variant.price / qty))} each` : '';
        if (add) add.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        try { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); } catch (_) {}
      };

      root.querySelectorAll('[data-pbc-option]').forEach((input) => input.addEventListener('change', update));
      update();
    });
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

